/* eslint-disable no-unused-vars */
import React, { FC, memo, useCallback, useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { Branch } from 'src/types';
import { slices, useAppDispatch } from 'src/redux';

const { actions: branchActions } = slices.branch;

interface Props {
  label?: string;
  branches: Branch[];
  user_id?: string | undefined;
  onBranchChanged?: (branch_id: number | '') => void;
}

const Component: FC<Props> = ({
  label = 'Default Branch',
  branches = [],
  user_id,
  onBranchChanged
}) => {
  const dispatch = useAppDispatch();

  const [branchOptions, setBranchOptions] = useState<Branch[]>([]);
  const [selectedBranchId, setSelectedBranchId] = useState<number | ''>('');

  const handleChange = useCallback(
    async (event: React.ChangeEvent<{ value: any }>) => {
      const branch_id = event.target.value;
      setSelectedBranchId(branch_id);

      if (!user_id || isNaN(+user_id)) return;
      const userId = +user_id;
      if (!branch_id) return;

      try {
        dispatch(
          branchActions.makeDefaultBranchToUserThunk({
            user_id: userId,
            branch_id: branch_id
          })
        );

        if (onBranchChanged) {
          onBranchChanged(branch_id);
        }
      } catch (error) {
        console.error('Failed to set default branch:', error);
      }
    },
    [dispatch, onBranchChanged, user_id]
  );

  useEffect(() => {
    if (branches.length > 0 && selectedBranchId === '') {
      const sorted = [...branches].sort(
        (a, b) => (a?.pivot?.sort_order ?? 0) - (b?.pivot?.sort_order ?? 0)
      );
      setBranchOptions(sorted);
      const defaultBranch = sorted.find((b) => b?.pivot?.sort_order === 1);
      const initialId = defaultBranch ? defaultBranch.id : '';
      setSelectedBranchId(initialId);
    } else {
      setBranchOptions([...branches]);
    }
  }, [branches, selectedBranchId, onBranchChanged]);

  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select value={selectedBranchId} onChange={handleChange} label={label}>
        {branchOptions.map((branch) => (
          <MenuItem key={branch.id} value={branch.id}>
            {branch.branch_name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export const DefaultBranchDropDown = memo(Component);
